var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-urgent-apply" },
    [
      _c("el-card", { staticClass: "apply-card", attrs: { shadow: "never" } }, [
        _c(
          "div",
          {
            staticClass: "apply-card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", [_vm._v("加急申请")]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.openUrgentApplyDialog },
              },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _vm._v(" 新增加急申请\n      "),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.urgentApplyList.length > 0
          ? _c(
              "div",
              { staticClass: "apply-list" },
              _vm._l(_vm.urgentApplyList, function (item, index) {
                return _c(
                  "el-card",
                  {
                    key: item.rowId,
                    staticClass: "apply-item",
                    attrs: { shadow: "never" },
                  },
                  [
                    _c("div", { staticClass: "apply-item-header" }, [
                      _c("span", { staticClass: "apply-serial-number" }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "apply-type" }, [
                        _vm._v("加急申请"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "apply-time" }, [
                        _vm._v(_vm._s(item.createTime)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "apply-item-content" }, [
                      _c("p", [
                        _c("strong", [_vm._v("申请明细：")]),
                        _vm._v(_vm._s(item.applicationDetails)),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [_vm._v("明细描述：")]),
                        _vm._v(_vm._s(item.detailedDescription)),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [_vm._v("是否在签订回执后购买物料：")]),
                        _vm._v(_vm._s(item.isMaterial)),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [_vm._v("是否需要打样：")]),
                        _vm._v(_vm._s(item.isProofing)),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [_vm._v("客户地址：")]),
                        _vm._v(_vm._s(item.custAddress)),
                      ]),
                      _vm._v(" "),
                      item.file
                        ? _c(
                            "p",
                            { staticClass: "attachments" },
                            [
                              _c("strong", [_vm._v("附件：")]),
                              _vm._v(" "),
                              Array.isArray(item.file)
                                ? _vm._l(item.file, function (file, fileIndex) {
                                    return _c(
                                      "el-link",
                                      {
                                        key: fileIndex,
                                        staticClass: "file-link",
                                        attrs: {
                                          href: _vm.getPreviewUrl(
                                            file.realName
                                          ),
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(file.realName) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  })
                                : [
                                    _c(
                                      "el-link",
                                      {
                                        staticClass: "file-link",
                                        attrs: {
                                          href: _vm.getPreviewUrl(item.file),
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.file) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
              1
            )
          : _c(
              "div",
              { staticClass: "empty-state" },
              [_c("el-empty", { attrs: { description: "暂无加急申请记录" } })],
              1
            ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增加急申请",
            visible: _vm.urgentApplyDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.urgentApplyDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.urgentApplyForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "applicationDetails" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请明细"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "4",
                      placeholder: "请输入申请明细",
                    },
                    model: {
                      value: _vm.urgentApplyForm.applicationDetails,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "applicationDetails", $$v)
                      },
                      expression: "urgentApplyForm.applicationDetails",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "detailedDescription" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 明细描述"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "4",
                      placeholder: "请输入明细描述",
                    },
                    model: {
                      value: _vm.urgentApplyForm.detailedDescription,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.urgentApplyForm,
                          "detailedDescription",
                          $$v
                        )
                      },
                      expression: "urgentApplyForm.detailedDescription",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "isMaterial" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 是否在签订回执后购买物料"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.urgentApplyForm.isMaterial,
                        callback: function ($$v) {
                          _vm.$set(_vm.urgentApplyForm, "isMaterial", $$v)
                        },
                        expression: "urgentApplyForm.isMaterial",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "是", value: "是" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "否", value: "否" } }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "isProofing" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 是否需要打样"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.urgentApplyForm.isProofing,
                        callback: function ($$v) {
                          _vm.$set(_vm.urgentApplyForm, "isProofing", $$v)
                        },
                        expression: "urgentApplyForm.isProofing",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "是", value: "是" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "否", value: "否" } }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custAddress" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户地址"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户地址" },
                    model: {
                      value: _vm.urgentApplyForm.custAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "custAddress", $$v)
                      },
                      expression: "urgentApplyForm.custAddress",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("CommonUpload", {
                    ref: "upload",
                    attrs: { multiple: true, "max-size": 10, "max-count": 10 },
                    on: {
                      "upload-success": _vm.handleUploadSuccess,
                      remove: _vm.handleRemove,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.urgentApplyDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitUrgentApply },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }